/**
 * The shop's mark: its logo when it has one, otherwise the first letters of
 * its name on the shop's colour. Used wherever the shop introduces itself -
 * the menu, the sign-in screen, first-time setup.
 */
export function ShopMark({ name, logo, size }: { name: string; logo?: string | null; size?: number }) {
  const style = size ? { width: size, height: size, fontSize: Math.round(size * 0.38) } : undefined;
  return (
    <div className={`nav-mark ${logo ? 'has-logo' : ''}`} style={style} aria-hidden>
      {logo ? <img src={logo} alt="" /> : name.slice(0, 2)}
    </div>
  );
}
